import React, { ReactNode, useEffect } from 'react';
import { useResolve } from '../../../Container';
import { ProfileModel } from '../../../ProfileModel';
import { jiraOAuthRequiredPopup } from '../../../external/atlassian/JiraOAuthRequiredPopup';
import { PopupManager } from '../../../popups/PopupManager';


export type JiraOAuthRequiredProps = { children?: ReactNode, onReject(): void };

export const JiraOAuthRequired = ({ children, onReject }: { children?: ReactNode, onReject?(): void }) => {
    const { connections } = useResolve(ProfileModel);
    const popups = useResolve(PopupManager);
    const authed = !!connections.find(x => x.externalSystemType === 'atlassian-oauth');

    useEffect(() => {
        if (!authed) {
            popups.invoke(jiraOAuthRequiredPopup());
            if (onReject) onReject();
        }
    }, [authed]);

    return <>
        {authed && <>{children}</>}
    </>;
};
